import { Cart } from '../../../../types';

export type GetCart = () => Promise<Partial<Cart>>;

export const getCartLive: GetCart = async () => {
  try {
    const getCart = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await getCart.json();
  } catch (error) {
    return error;
  }
};
